// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDDo3UdLlAJSi6obLnFDMdgKUpkPree4Wc",
  authDomain: "mudah-web.firebaseapp.com",
  projectId: "mudah-web",
  storageBucket: "mudah-web.appspot.com",
  messagingSenderId: "1074662364591",
  appId: "1:1074662364591:web:0f134bd1b82e8fd85f8b5a",
  measurementId: "G-15H186EGXP"
};

// Initialize Firebase/firestore
const app = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(app);
export const firebaseStorage = getStorage(app);
export default getFirestore();